import React from "react"

export const Logo = () => (
  <svg
    width="131"
    height="22"
    viewBox="0 0 131 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.9153 7.95C15.8653 5.79 13.8253 4.53 11.4553 4.53C7.97527 4.53 5.30527 7.26 5.30527 10.8C5.30527 14.34 7.97527 17.07 11.4553 17.07C13.8253 17.07 15.8653 15.81 16.9153 13.65L20.7853 15.93C18.9553 19.32 15.3553 21.48 11.4553 21.48C5.51527 21.48 0.745274 16.74 0.745274 10.8C0.745274 4.86 5.51527 0.119999 11.4553 0.119999C15.3853 0.119999 18.9553 2.25 20.7853 5.67L16.9153 7.95ZM36.9623 0.6H41.4023V21H36.9623V12.93H28.3223V21H23.8823V0.6H28.3223V8.67H36.9623V0.6ZM60.4809 4.86H50.8509V8.79H57.3909V12.81H50.8509V16.74H60.4809V21H46.4409V0.6H60.4809V4.86ZM78.352 4.86H68.722V8.79H75.262V12.81H68.722V16.74H78.352V21H64.312V0.6H78.352V4.86ZM105.673 0.6V21H101.263V7.47L96.0731 21H91.6631L86.5931 7.65V21H82.1831V0.6H88.4531L93.8831 14.94L99.3731 0.6H105.673ZM125.335 21L123.625 16.83H115.105L113.425 21H108.625L117.115 0.6H121.525L130.135 21H125.335ZM116.665 13.02H122.035L119.335 6.45L116.665 13.02Z"
      fill="white"
    />
  </svg>
)

export const BigLogo = () => (
  <svg
    width="1154"
    height="317"
    viewBox="0 0 1154 317"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.16769 137.127L0 3.68311H30.0164L83.4037 105.822L136.86 3.68311H164.111L164.472 137.127H141.599V35.5243L85.928 140.041H80.2784L23.8689 36.7937V137.127H1.16769Z"
      fill="#F2EAD7"
    />
    <path
      d="M250.022 118.39V75.9829L309.145 75.9472V57.3359L250.022 57.3716V21.9011H327.193V3.68311H226.222V137.127H328.807V118.39H250.022Z"
      fill="#F2EAD7"
    />
    <path
      d="M408.741 278.633H377.042V252.281H365.657V316.088H377.042V288.752H408.741V316.088H420.04V252.281H408.741V278.633Z"
      fill="#F2EAD7"
    />
    <path
      d="M516.048 260.63C513.095 257.68 509.609 255.409 505.59 253.8C501.572 252.191 497.193 251.387 492.454 251.387C487.663 251.387 483.267 252.209 479.232 253.854C475.196 255.499 471.693 257.787 468.722 260.737C465.752 263.687 463.434 267.155 461.802 271.124C460.171 275.111 459.347 279.474 459.347 284.211C459.347 288.895 460.171 293.222 461.802 297.209C463.434 301.196 465.735 304.664 468.722 307.65C471.693 310.635 475.213 312.942 479.266 314.587C483.319 316.231 487.715 317.054 492.437 317.054C497.159 317.054 501.538 316.249 505.573 314.64C509.609 313.031 513.095 310.743 516.031 307.757C518.985 304.771 521.268 301.303 522.9 297.316C524.531 293.329 525.355 288.967 525.355 284.229C525.355 279.491 524.531 275.111 522.9 271.106C521.286 267.048 518.984 263.58 516.048 260.63ZM512.27 293.222C511.189 295.957 509.695 298.335 507.754 300.338C505.831 302.34 503.564 303.895 500.971 304.986C498.378 306.076 495.528 306.631 492.437 306.631C489.346 306.631 486.461 306.076 483.817 304.986C481.155 303.895 478.871 302.322 476.948 300.284C475.025 298.246 473.496 295.868 472.397 293.133C471.281 290.397 470.732 287.429 470.732 284.193C470.732 280.904 471.281 277.918 472.397 275.218C473.513 272.519 475.025 270.141 476.948 268.103C478.871 266.065 481.172 264.509 483.817 263.401C486.478 262.31 489.346 261.756 492.437 261.756C495.528 261.756 498.378 262.31 500.971 263.401C503.564 264.492 505.848 266.047 507.806 268.049C509.763 270.052 511.257 272.429 512.322 275.165C513.369 277.9 513.902 280.904 513.902 284.193C513.902 287.465 513.352 290.469 512.27 293.222Z"
      fill="#F2EAD7"
    />
    <path
      d="M561.09 262.31H581.404V316.088H592.789V262.31H613.103V252.281H561.09V262.31Z"
      fill="#F2EAD7"
    />
    <path
      d="M665.461 288.556H695.048V278.812H665.461V262.31H698.808V252.281H654.076V316.088H700.045V306.059H665.461V288.556Z"
      fill="#F2EAD7"
    />
    <path
      d="M760.009 306.059V252.281H748.641V316.088H792.069V306.059H760.009Z"
      fill="#F2EAD7"
    />
    <path
      d="M1075.23 118.39V75.9829L1134.34 75.9472V57.3359L1075.23 57.3716V21.9011H1152.39V3.68311H1051.42V137.127H1154V118.39H1075.23Z"
      fill="#F2EAD7"
    />
    <path
      d="M641.867 37.6875L658.18 25.2621C658.18 25.2621 643.79 2.10967 608.983 0.0894259C574.175 -1.93082 541.051 28.0332 540.81 65.0234C539.849 103.444 562.31 134.82 601.736 138.771C632.766 141.882 654.437 119.141 656.617 115.369C651.535 111.096 640.184 102.282 640.184 102.282C640.184 102.282 630.035 117.89 606.579 117.389C583.122 116.888 562.104 97.3652 562.344 69.6181C562.584 41.871 582.16 23.2597 604.896 21.4897C627.597 19.7198 641.867 37.6875 641.867 37.6875Z"
      fill="#F2EAD7"
    />
    <path
      d="M470.354 83.903C470.354 83.903 491.871 74.2129 490.291 43.1226C488.78 13.1943 469.994 6.36481 450.898 4.11214C449.439 3.93336 447.979 3.84397 446.52 3.77245C424.54 2.89642 391.175 3.36125 391.175 3.36125V136.876H412.331V90.6967H450.28L473.119 136.876H496.696L470.354 83.903ZM445.575 70.5658H412.691V23.1168H447.258C447.258 23.1168 470.114 22.1156 470.097 46.2692C470.097 71.9603 445.575 70.5658 445.575 70.5658Z"
      fill="#F2EAD7"
    />
    <path
      d="M970.502 84.2426C970.502 84.2426 992.018 74.5525 990.438 43.4622C988.927 13.5339 970.141 6.70441 951.046 4.45174C949.586 4.27296 948.127 4.18357 946.667 4.11205C924.687 3.23602 891.322 3.70085 891.322 3.70085V137.216H912.478V91.0363H950.428L973.266 137.216H996.843L970.502 84.2426ZM945.723 70.9054H912.839V23.4564H947.405C947.405 23.4564 970.261 22.4552 970.244 46.6088C970.244 72.2999 945.723 70.9054 945.723 70.9054Z"
      fill="#F2EAD7"
    />
    <path
      d="M810.649 4.12988V74.4273C810.649 74.4273 811.13 91.5369 800.02 103.783C794.147 110.255 786.694 113.491 780.77 115.1C774.107 116.924 767.05 116.799 760.49 114.582C755.304 112.83 749.105 109.612 743.816 103.783C732.689 91.5369 733.187 74.4273 733.187 74.4273V4.12988H711.756V77.2879C713.199 94.2365 715.465 107.162 731.264 123.092C747.13 138.128 763.186 139.486 769.059 139.415C770.415 139.397 771.772 139.397 773.129 139.415C779.293 139.504 796.62 138.271 812.624 123.092C828.422 107.145 830.671 94.2365 832.131 77.2879V4.12988H810.649Z"
      fill="#F2EAD7"
    />
  </svg>
)

export const LogoDouble = () => (
  <svg
    width="260"
    height="98"
    viewBox="0 0 260 98"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M32.8305 15.9C30.7305 11.58 26.6505 9.06 21.9105 9.06C14.9505 9.06 9.61055 14.52 9.61055 21.6C9.61055 28.68 14.9505 34.14 21.9105 34.14C26.6505 34.14 30.7305 31.62 32.8305 27.3L40.5705 31.86C36.9105 38.64 29.7105 42.96 21.9105 42.96C10.0305 42.96 0.490547 33.48 0.490547 21.6C0.490547 9.72 10.0305 0.239998 21.9105 0.239998C29.7705 0.239998 36.9105 4.5 40.5705 11.34L32.8305 15.9ZM72.9246 1.2H81.8046V42H72.9246V25.86H55.6446V42H46.7646V1.2H55.6446V17.34H72.9246V1.2ZM119.962 9.72H100.702V17.58H113.782V25.62H100.702V33.48H119.962V42H91.8818V1.2H119.962V9.72ZM155.704 9.72H136.444V17.58H149.524V25.62H136.444V33.48H155.704V42H127.624V1.2H155.704V9.72ZM210.346 1.2V42H201.526V14.94L191.146 42H182.326L172.186 15.3V42H163.366V1.2H175.906L186.766 29.88L197.746 1.2H210.346ZM249.671 42L246.251 33.66H229.211L225.851 42H216.251L233.231 1.2H242.051L259.271 42H249.671ZM232.331 26.04H243.071L237.671 12.9L232.331 26.04ZM45.4608 74.5H67.2408V77.56C67.2408 89.68 58.7208 97.96 47.5008 97.96C35.4408 97.96 26.0808 88.54 26.0808 76.66C26.0808 64.72 35.5608 55.24 47.4408 55.24C54.9408 55.24 61.7808 59.08 65.5608 65.38L58.0608 69.88C55.8408 66.04 52.0008 63.88 47.4408 63.88C40.3008 63.88 35.0808 69.34 35.0808 76.72C35.0808 83.98 40.1808 89.32 47.6208 89.32C53.5008 89.32 57.0408 85.96 57.5808 82.18H45.4608V74.5ZM97.5014 97L88.8014 81.88H82.8014V97H73.9814V56.2H91.8614C99.8414 56.2 105.901 61.66 105.901 68.98C105.901 74.2 102.841 78.52 98.2214 80.56L107.641 97H97.5014ZM82.8014 64.66V73.84H91.8614C94.8614 73.84 97.0814 71.86 97.0814 69.28C97.0814 66.58 94.8614 64.66 91.8614 64.66H82.8014ZM131.276 97.96C119.336 97.96 109.856 88.48 109.856 76.6C109.856 64.72 119.336 55.24 131.276 55.24C143.036 55.24 152.516 64.72 152.516 76.6C152.516 88.48 143.036 97.96 131.276 97.96ZM131.276 89.14C138.116 89.14 143.396 83.68 143.396 76.6C143.396 69.52 138.116 64.06 131.276 64.06C124.316 64.06 118.976 69.52 118.976 76.6C118.976 83.68 124.316 89.14 131.276 89.14ZM184.562 56.2H193.562V79C193.562 90.34 186.422 97.96 175.922 97.96C165.422 97.96 158.282 90.34 158.282 79V56.2H167.282V78.88C167.282 85.24 170.702 89.32 175.922 89.32C181.142 89.32 184.562 85.24 184.562 78.88V56.2ZM219.833 56.2C227.813 56.2 233.873 61.9 233.873 69.22C233.873 76.54 227.873 82.3 219.833 82.3H210.713V97H201.833V56.2H219.833ZM219.833 73.84C222.833 73.84 225.053 71.86 225.053 69.28C225.053 66.58 222.833 64.66 219.833 64.66H210.713V73.84H219.833Z"
      fill="white"
    />
  </svg>
)

export const ArrowRight = ({ color = "#F2EAD7" }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 22.5C12 21.39 13.1 19.729 14.212 18.334C15.644 16.538 17.353 14.969 19.314 13.771C20.783 12.874 22.567 12.013 24 12.013M12 1.5C12 2.61 13.1 4.271 14.212 5.666C15.644 7.462 17.353 9.031 19.314 10.229C20.783 11.126 22.567 11.987 24 11.987M24 12L9.17939e-07 12"
      stroke={color}
    />
  </svg>
)

export const ArrowRightSlider = ({ color = "#F2EAD7" }) => (
  <svg
    width="29"
    height="29"
    viewBox="0 0 29 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.5 28C15.5 26.7314 14.2625 24.8331 13.0115 23.2389C11.4005 21.1863 9.47787 19.3931 7.27175 18.024C5.61912 16.9989 3.61212 16.0149 2 16.0149M15.5 4C15.5 5.26857 14.2625 7.16686 13.0115 8.76114C11.4005 10.8137 9.47787 12.6069 7.27175 13.976C5.61912 15.0011 3.61212 15.9851 2 15.9851M2 16L29 16"
      stroke="#F2EAD7"
    />
  </svg>
)

export const ArrowLeftSlider = ({ color = "#F2EAD7" }) => (
  <svg
    width="29"
    height="29"
    viewBox="0 0 29 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.5 28C13.5 26.7314 14.7375 24.8331 15.9885 23.2389C17.5995 21.1863 19.5221 19.3931 21.7283 18.024C23.3809 16.9989 25.3879 16.0149 27 16.0149M13.5 4C13.5 5.26857 14.7375 7.16686 15.9885 8.76114C17.5995 10.8137 19.5221 12.6069 21.7283 13.976C23.3809 15.0011 25.3879 15.9851 27 15.9851M27 16L-1.81195e-06 16"
      stroke="#F2EAD7"
    />
  </svg>
)

export const MainLogo = () => (
  <svg
    width="168"
    height="45"
    viewBox="0 0 168 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_237_1162)">
      <path
        d="M0.169992 19.4659L0 0.522812H4.36981L12.142 15.022L19.9241 0.522812H23.8914L23.9439 19.4659H20.6141V5.04286L12.5094 19.8796H11.687L3.47485 5.22305V19.4659H0.169992Z"
        fill="#F2EAD7"
      />
      <path
        d="M36.3983 16.8062V10.7862L45.0054 10.7811V8.13913L36.3983 8.14421V3.10896H47.6328V0.522812H32.9335V19.4659H47.8678V16.8062H36.3983Z"
        fill="#F2EAD7"
      />
      <path
        d="M59.5049 39.5536H54.8901V35.8127H53.2327V44.8706H54.8901V40.9901H59.5049V44.8706H61.1498V35.8127H59.5049V39.5536Z"
        fill="#F2EAD7"
      />
      <path
        d="M75.1267 36.9979C74.6967 36.5792 74.1892 36.2568 73.6043 36.0284C73.0193 35.8 72.3818 35.6858 71.6919 35.6858C70.9944 35.6858 70.3544 35.8026 69.7669 36.036C69.1795 36.2695 68.6695 36.5944 68.237 37.0131C67.8045 37.4319 67.467 37.9243 67.2296 38.4877C66.9921 39.0536 66.8721 39.6729 66.8721 40.3454C66.8721 41.0104 66.9921 41.6246 67.2296 42.1905C67.467 42.7565 67.802 43.2488 68.237 43.6727C68.6695 44.0965 69.182 44.4239 69.7719 44.6574C70.3619 44.8909 71.0019 45.0076 71.6894 45.0076C72.3768 45.0076 73.0143 44.8934 73.6018 44.665C74.1892 44.4366 74.6967 44.1117 75.1242 43.6879C75.5542 43.2641 75.8867 42.7717 76.1242 42.2057C76.3617 41.6398 76.4816 41.0205 76.4816 40.348C76.4816 39.6754 76.3617 39.0536 76.1242 38.4851C75.8892 37.909 75.5542 37.4167 75.1267 36.9979ZM74.5767 41.6246C74.4192 42.0129 74.2017 42.3504 73.9193 42.6347C73.6393 42.9189 73.3093 43.1397 72.9318 43.2945C72.5543 43.4493 72.1393 43.528 71.6894 43.528C71.2394 43.528 70.8194 43.4493 70.4344 43.2945C70.0469 43.1397 69.7144 42.9164 69.4345 42.627C69.1545 42.3377 68.932 42.0002 68.772 41.6119C68.6095 41.2236 68.5295 40.8023 68.5295 40.3429C68.5295 39.8759 68.6095 39.4521 68.772 39.0689C68.9345 38.6856 69.1545 38.3481 69.4345 38.0588C69.7144 37.7694 70.0494 37.5486 70.4344 37.3913C70.8219 37.2365 71.2394 37.1578 71.6894 37.1578C72.1393 37.1578 72.5543 37.2365 72.9318 37.3913C73.3093 37.5461 73.6418 37.7669 73.9268 38.0512C74.2117 38.3354 74.4292 38.6729 74.5842 39.0613C74.7367 39.4496 74.8142 39.8759 74.8142 40.3429C74.8142 40.8073 74.7342 41.2337 74.5767 41.6246Z"
        fill="#F2EAD7"
      />
      <path
        d="M81.6838 37.2365H84.6412V44.8706H86.2986V37.2365H89.256V35.8127H81.6838V37.2365Z"
        fill="#F2EAD7"
      />
      <path
        d="M96.8783 40.9622H101.186V39.579H96.8783V37.2365H101.733V35.8127H95.2208V44.8706H101.913V43.4468H96.8783V40.9622Z"
        fill="#F2EAD7"
      />
      <path
        d="M110.643 43.4468V35.8127H108.988V44.8706H115.31V43.4468H110.643Z"
        fill="#F2EAD7"
      />
      <path
        d="M156.533 16.8062V10.7862L165.138 10.7811V8.13913L156.533 8.14421V3.10896H167.765V0.522812H153.066V19.4659H168V16.8062H156.533Z"
        fill="#F2EAD7"
      />
      <path
        d="M93.4433 5.34995L95.8182 3.5861C95.8182 3.5861 93.7233 0.299478 88.6561 0.0126925C83.5888 -0.274093 78.7665 3.97947 78.7315 9.23045C78.5915 14.6845 81.8614 19.1385 87.6011 19.6994C92.1184 20.141 95.2733 16.9128 95.5907 16.3773C94.8508 15.7707 93.1983 14.5195 93.1983 14.5195C93.1983 14.5195 91.7209 16.7351 88.3061 16.664C84.8912 16.593 81.8314 13.8216 81.8664 9.88269C81.9014 5.94383 84.7512 3.30185 88.0611 3.05059C91.3659 2.79934 93.4433 5.34995 93.4433 5.34995Z"
        fill="#F2EAD7"
      />
      <path
        d="M68.4745 11.9105C68.4745 11.9105 71.6069 10.5349 71.3769 6.12148C71.1569 1.87299 68.422 0.903504 65.6421 0.583725C65.4296 0.558345 65.2171 0.545656 65.0046 0.535504C61.8048 0.411145 56.9475 0.477132 56.9475 0.477132V19.4304H60.0274V12.8749H65.5521L68.877 19.4304H72.3093L68.4745 11.9105ZM64.8672 10.0172H60.0799V3.28154H65.1121C65.1121 3.28154 68.4395 3.13942 68.437 6.56816C68.437 10.2152 64.8672 10.0172 64.8672 10.0172Z"
        fill="#F2EAD7"
      />
      <path
        d="M141.286 11.9587C141.286 11.9587 144.419 10.5832 144.189 6.1697C143.969 1.92121 141.234 0.951721 138.454 0.631942C138.241 0.606563 138.029 0.593873 137.816 0.583722C134.617 0.459363 129.759 0.525349 129.759 0.525349V19.4786H132.839V12.9231H138.364L141.689 19.4786H145.121L141.286 11.9587ZM137.679 10.0654H132.892V3.32976H137.924C137.924 3.32976 141.251 3.18764 141.249 6.61638C141.249 10.2634 137.679 10.0654 137.679 10.0654Z"
        fill="#F2EAD7"
      />
      <path
        d="M118.015 0.586258V10.5654C118.015 10.5654 118.085 12.9942 116.467 14.7327C115.612 15.6514 114.527 16.1108 113.665 16.3392C112.695 16.598 111.668 16.5803 110.713 16.2656C109.958 16.0169 109.055 15.56 108.285 14.7327C106.665 12.9942 106.738 10.5654 106.738 10.5654V0.586258H103.618V10.9715C103.828 13.3774 104.158 15.2123 106.458 17.4736C108.768 19.608 111.105 19.8009 111.96 19.7908C112.158 19.7882 112.355 19.7882 112.553 19.7908C113.45 19.8035 115.972 19.6283 118.302 17.4736C120.602 15.2098 120.93 13.3774 121.142 10.9715V0.586258H118.015Z"
        fill="#F2EAD7"
      />
    </g>
  </svg>
)
